import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { IActivityRepository } from '@/modules/documents/domain/repositories/activity.repository';

export namespace GetDocumentActivity {
  export const key = (input: Input) => [
    'documents',
    'get-document-activity',
    ...Object.entries(input).flatMap(([key, value]) => [key, value]),
  ];

  export type Input = IActivityRepository.GetAllInput;
  export type Output = IActivityRepository.GetAllOutput;

  export type Params = {
    refetchInterval?: number;
  };

  export function useQuery(input: Input, params: Params = {}) {
    const { repositories } = useDependencies();
    return rq.useQuery<Output>({
      refetchInterval: params.refetchInterval,
      queryKey: key(input),
      queryFn: () => repositories.documentActivity.getAll(input),
    });
  }
}
